export default __webpack_public_path__ + "static/icon-32-3-b3cfa33017c4db0970db7bb87ffea34b.png";